import { render, staticRenderFns } from "./ProjectsPgHeader.vue?vue&type=template&id=62b64a51&scoped=true&"
import script from "./ProjectsPgHeader.vue?vue&type=script&lang=js&"
export * from "./ProjectsPgHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsPgHeader.vue?vue&type=style&index=0&id=62b64a51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b64a51",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
